export const NotificationTarget = {
  ALL: "ALL",
  TEACHERS: "TEACHERS",
  CENTERS: "CENTERS",
  LXOS: "LXOS",
};
